import InviteApi from '../../api/InviteApi';
import DDLogs from '../../DDLogs';
import Segment from '../../Segment';

const state = {
  customerId: '',
  accessToken: '',
  primaryMemberDetails: {},
};

const actions = {
  async init({ commit }, accessToken) {
    commit('setAccessToken', accessToken);
    if (accessToken) {
      try {
        const inviteDetails = await InviteApi.getInviteDetails();
        commit('setCustomerId', inviteDetails.customerId);
        commit('setPrimaryMemberDetails', inviteDetails);
        DDLogs.addGlobalContext('customerId', inviteDetails.customerId);
        Segment.identifyCustomer(inviteDetails.customerId);
      } catch (e) {
        // Added this in order to avoid sentry issues with 403 errors
        console.log('Could not authenticate', e);
      }
    }
  },
};

const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  setPrimaryMemberDetails(state, primaryMemberDetails) {
    state.primaryMemberDetails = primaryMemberDetails;
  },
  setCustomerId(state, customerId) {
    state.customerId = customerId;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
